module.exports = __webpack_public_path__ + "static/img/login.8dfe44af.jpg";